export default __webpack_public_path__ + "static/media/space.2cf452bd.jpg";